'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { ProgressBar } from '../progress-bar';
import { ProgressStepperRootContext } from './context/progress-stepper-root.context';
import { progressStepperBarRecipe } from './styles/progress-stepper-bar.styles';
import type { ProgressStepperBarPropsInterface } from './types/progress-stepper-bar.types';

/**
 * ProgressStepper.Bar
 *
 * @related ['Progress']
 * @since 10.0.0
 */
export const ProgressStepperBar = forwardRef<HTMLDivElement, ProgressStepperBarPropsInterface>(
  (props: ProgressStepperBarPropsInterface, forwardedRef) => {
    const { css: cssProp, ...rest } = props;
    const { activeStepIndex, orientation, steps } = useContext(ProgressStepperRootContext);

    return (
      <ProgressBar
        value={activeStepIndex + 1}
        minValue={0}
        maxValue={steps.length}
        ref={forwardedRef}
        css={css.raw(progressStepperBarRecipe.raw({ orientation }), cssProp)}
        data-c11n-component="ProgressStepper.Bar"
        data-c11n-version={__C11N_VERSION__}
        stepperOffset
        {...rest}
        aria-hidden
        className={cx('c11n_progress-stepper__bar', rest.className)}
      />
    );
  },
);

ProgressStepperBar.displayName = 'ProgressStepper.Bar';
